module.exports = __webpack_public_path__ + "officialStatic/img/product-zndj.a540feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-zndj.png
// module id = nIXj
// module chunks = 0